import moment from "moment";
import { Select } from "antd";
import { Link } from 'react-router-dom';
import { statusOptions } from "../../enums/pcc_status";

const PCCCard = ({ pqr, assignables, onSelect, onPriorityChange, onStatusChange, onAssignedChange }) => {
  return (
    <div
      className="card mb-3"
      onClick={() => onSelect(pqr.id)}
      style={{ cursor: "pointer" }}
    >
      <div className="card-body">
        <h5 className="card-title">PQR #{pqr.id}</h5>
        <table className="table table-borderless mb-0 w-auto">
          <tbody>
            <tr>
              <th>Usuario</th>
              <td>
                <Link to={`/users/${pqr.user_id}`}>{pqr.user_id} {pqr.reporter_name}</Link>
              </td>
            </tr>
            <tr>
              <th>Status</th>
              <td>
                <Select
                  value={pqr.status}
                  onChange={(value) => onStatusChange(pqr.id, value)}
                  onClick={(e) => e.stopPropagation()} // prevent card click
                  style={{ width: 200 }}
                  options={statusOptions}
                />
              </td>
            </tr>
            <tr>
              <th>Priority</th>
              <td>
                <Select
                  value={pqr.priority}
                  onChange={(value) => onPriorityChange(pqr.id, value)}
                  onClick={(e) => e.stopPropagation()}
                  style={{ width: 150 }}
                  options={[
                    { value: 1, label: 'Baja' },
                    { value: 2, label: 'Media' },
                    { value: 3, label: 'Alta' },
                    { value: 4, label: 'Super Alta' },
                  ]}
                />
              </td>
            </tr>
            <tr>
              <th>Asignado</th>
              <td>
                <Select
                  value={pqr.assigned_to}
                  onChange={(value) => onAssignedChange(pqr.id, value)}
                  onClick={(e) => e.stopPropagation()}
                  style={{ width: 150 }}
                  options={assignables ? assignables.map(a => ({
                    value: a.id,
                    label: a.name,
                  })) : []}
                />
              </td>
            </tr>
            <tr>
              <th>Created</th>
              <td>{moment(pqr.created_at).utc().format("DD/MM/YYYY HH:mm")}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PCCCard;